module.exports = __webpack_public_path__ + "static/media/29BDOS22.0e158f57.jpg";